<template>
  <div id="navTitle" class="navTitle" :style="'background:' + color + ';color:' + font">
    <Button
      v-if="isback"
      icon="back"
      :style="'color:' + font"
      slot="left"
      @click.native="goback()"
    ></Button>
    <div class="ntitle">{{ title }}</div>

    <div class="rightIcon" v-if="ask" @click="goHelp">
      <svg t="1638060647642" id="shouzhishi" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2403" width="200" height="200"><path d="M715.813117 414.365855a53.090625 53.090625 0 0 0-4.85585 34.638395v453.212654a281.315569 281.315569 0 0 1-3.560957 49.529669 85.786681 85.786681 0 0 1-166.717512 11.654039 148.589006 148.589006 0 0 1-7.445636-52.119455v-199.413567c0-17.157336 0-28.487653-22.984356-18.775953a71.866578 71.866578 0 0 1-89.023914-24.27925c-9.7117-11.65404-15.862443-13.920103-30.106269-4.855849a78.664768 78.664768 0 0 1-117.187844-29.1351c-11.006593-20.718293-17.157336-30.106269-44.673818-19.423399A75.751258 75.751258 0 0 1 127.93156 550.329651a254.446533 254.446533 0 0 1-4.85585-49.529669c0-55.032965 1.618617-110.06593 0-165.098895a283.257909 283.257909 0 0 1 42.407756-186.464635c22.336909-32.372332 9.064253-70.895408 10.035423-106.828697C176.490059 0 175.195165 0 218.574091 0h461.305737c26.221589 0 36.580736 8.093083 32.372332 32.372332a179.018998 179.018998 0 0 0 64.744665 170.602192 1298.130529 1298.130529 0 0 1 92.908594 104.562634 99.706784 99.706784 0 0 1 19.099676 123.014863 79.959661 79.959661 0 0 1-129.48933 25.574143c-14.56755-11.65404-27.840206-26.221589-43.702648-41.760309z" fill="#ffcb21" p-id="2404"></path></svg>
      <!--<svg t="1583284262681" style="color: red" class="icon" viewBox="0 0 1024 1024"
        version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2776"
        width="128" height="128">
        <path d="M512 936.740571A424.740571 424.740571 0 1 0 512 87.259429a424.740571 424.740571 0 0 0 0 849.481142z m0 64A488.740571 488.740571 0 1 1 512 23.186286a488.740571 488.740571 0 0 1 0 977.554285zM422.765714 436.297143v0.658286a32.036571 32.036571 0 1 1-64-2.706286c0-47.250286 13.312-86.162286 39.570286-116.882286 28.818286-33.060571 68.461714-49.298286 118.710857-49.298286 44.763429 0 80.969143 12.946286 108.544 39.131429 26.477714 24.868571 39.643429 58.587429 39.643429 100.352 0 30.281143-9.435429 58.148571-27.794286 82.358857-7.606857 9.728-24.137143 25.819429-54.125714 52.955429a151.844571 151.844571 0 0 0-31.232 35.328c-8.411429 14.482286-12.434286 29.257143-12.434286 45.129143l1.097143 19.382857a11.190857 11.190857 0 0 1-11.190857 11.849143h-41.837715a11.190857 11.190857 0 0 1-11.264-11.190858v-19.382857c0-21.211429 4.388571-40.96 13.165715-58.148571 10.459429-22.528 32.182857-48.566857 63.634285-76.068572 19.602286-19.602286 25.746286-25.892571 29.769143-30.939428 12.8-16.530286 19.017143-32.841143 19.017143-49.956572 0-25.453714-7.314286-45.568-21.357714-60.196571-14.774857-14.774857-36.352-22.162286-65.609143-22.162286-32.621714 0-56.027429 10.532571-72.118857 31.890286-13.531429 16.969143-19.968 41.691429-19.968 75.849143 0 0.731429 0 1.389714-0.146286 2.048zM512 763.611429a31.963429 31.963429 0 1 1 0-64 31.963429 31.963429 0 0 1 0 63.926857z"
          p-id="2777" fill="#bfbfbf"></path>
      </svg>-->
      <svg t="1638317626544" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2288" width="200" height="200"><path d="M514.048 54.272q95.232 0 178.688 36.352t145.92 98.304 98.304 145.408 35.84 178.688-35.84 178.176-98.304 145.408-145.92 98.304-178.688 35.84-178.176-35.84-145.408-98.304-98.304-145.408-35.84-178.176 35.84-178.688 98.304-145.408 145.408-98.304 178.176-36.352zM515.072 826.368q26.624 0 44.544-17.92t17.92-43.52q0-26.624-17.92-44.544t-44.544-17.92-44.544 17.92-17.92 44.544q0 25.6 17.92 43.52t44.544 17.92zM567.296 574.464q-1.024-16.384 20.48-34.816t48.128-40.96 49.152-50.688 24.576-65.024q2.048-39.936-8.192-74.752t-33.792-59.904-60.928-39.936-87.552-14.848q-62.464 0-103.936 22.016t-67.072 53.248-35.84 64.512-9.216 55.808q1.024 26.624 16.896 38.912t34.304 12.8 33.792-10.24 15.36-31.232q0-12.288 7.68-30.208t20.992-34.304 32.256-27.648 42.496-11.264q46.08 0 73.728 23.04t25.6 57.856q0 17.408-10.24 32.256t-26.112 28.672-33.792 27.648-33.792 28.672-26.624 32.256-11.776 37.888l1.024 38.912q0 15.36 14.336 29.184t37.888 14.848q23.552-1.024 37.376-15.36t12.8-32.768l0-24.576z" p-id="2289" fill="#d81e06"></path></svg>
    </div>
    <div class="rightIcon" v-if="share" @click="goHelp">
      <svg t="1687158780970" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
           p-id="4373" width="128" height="128">
        <path d="M933.6 111.8c-2.1-5.2-5.2-9.9-9.3-14-4.1-4-8.8-7.1-14-9.3-5.2-2.1-10.8-3.2-16.3-3.2H680.7c-23.6 0-42.7 19.1-42.7 42.7s19.1 42.7 42.7 42.6H791L609.9 352c-16.7 16.7-16.7 43.7 0 60.3 16.6 16.7 43.7 16.7 60.3 0L851.4 231v110.4c0 23.6 19.1 42.7 42.7 42.7 11.8 0 22.5-4.8 30.2-12.5 7.7-7.7 12.5-18.4 12.5-30.2V128c0-5.5-1.1-11-3.2-16.2"
              fill="#00A2FF" p-id="4374"></path>
        <path d="M938.7 597.3V768c0 94.3-76.4 170.7-170.7 170.7H256c-94.3 0-170.7-76.4-170.7-170.7V256c0-94.3 76.4-170.7 170.7-170.7h170.7c23.6 0 42.7 19.1 42.7 42.7s-19.1 42.7-42.7 42.7H256c-47.1 0-85.3 38.2-85.3 85.3v512c0 47.1 38.2 85.3 85.3 85.3h512c47.1 0 85.3-38.2 85.3-85.3V597.3c0-23.6 19.1-42.7 42.7-42.7s42.7 19.2 42.7 42.7z"
              fill="#666666" p-id="4375"></path>
      </svg>
    </div>
    <!-- <span  @click.native="goback()" class="icon icon-xiangzuo"></span> -->
  </div>
</template>
<script>
import { Button } from "mint-ui";
import "mint-ui/lib/style.css";
export default {
  name: "navTitle",
  props: {
    title: String,
    path: {
      //如果没有传递目标页面则默认返回上一级页面
      type: String,
      default: ""
    },
    isback: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: "#fff"
    },
    font: {
      type: String,
      default: "#333"
    },
    ask: Boolean,
    askName:String,
    share: Boolean,
    shareUrl: String,
    tip_msg: String,
  },
  components: {
    Button
  },
  data: function() {
    return {};
  },
  methods: {
    goback() {
      if (this.path) {
        this.$router.push({ path: this.path });
        return;
      }
      // console.log('this.$router.',this.$router)
      // console.log('this.$router.',this.$router.app._route.path)
      this.$router.go(-1);
    },
    goHelp() {
      switch (this.askName) {
        case 'BANKS':this.$router.push({ path: "/user/cashHelp",query:{id:8}});break;
        case 'USDT':this.$router.push({ path: "/user/cashHelp",query:{id:7}});break;
        case 'Binance_te':this.$router.push({ path: "/user/cashHelp",query:{id:5}});break;
        case 'game':
          this.$dialog.confirm({
            mes: "Check the results on the lottery website?",
            title: "Hot-Spot",
            opts: [
              {
                txt: "Cancel",
                color: false,
                callback: () => {
                  return
                }
              },
              {
                txt: "To travel to",
                color: "#00C3F9",
                callback: () => {
                  location.href="https://www.calottery.com/draw-games/hot-spot#section-content-1-5"
                }
              }
            ]
          });
         ;break;
        case 'share':
          this.copy(this.shareUrl)
          // console.log(this.shareUrl)
          break;
        case 'club_lottery':
          this.$dialog.confirm({
            mes: this.tip_msg,
            title: "Luật xổ số",
            opts: [
              {
                txt: "Xác nhận",
                color: "#00C3F9",
                callback: () => {
                  return
                }
              }
            ]
          });
      }
    },
    copy(v) {
      v = String(v)
      const textarea = document.createElement("textarea");
      textarea.value = v
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      return this.$dialog.toast({mes: 'Liên kết chia sẻ được sao chép'})
    }
  }
};
</script>
<style scoped>
  #shouzhishi{
    margin-left: -20px;
    padding-right: 5px;
    font-size: .5rem;
    transform: rotate(270deg);
    ms-transform: rotate(270deg); /* IE 9 */
    moz-transform: rotate(270deg); /* Firefox */
    webkit-transform: rotate(270deg); /* Safari and Chrome */
    o-transform: rotate(270deg); /* Opera */
  }
.navTitle {
  width: 7.5rem;
  left: 0;
  right: 0;
  top:0px;
  margin: 0 auto;
  height: 1rem;
  position: fixed;
  display: flex;
  z-index: 9999;
 
}
.navTitle button {
  width: 0.6rem;
  height: 1rem;
  text-align: center;
  line-height: 1rem;
  background: none;
  box-shadow: none;
  color: #333;
  padding: 0px;
  position: absolute;
  left: 0.1rem;
  top: 0px;
}
.navTitle button::after {
  border: none;
  background: none;
}

.navTitle .ntitle {
  width: 100%;
  line-height: 1rem;
  text-align: center;
  padding: 0 0.3rem;
  box-sizing: border-box;
}
.rightIcon {
  position: absolute;
  top: 0px;
  right: 0px;
  width: 50px;
  line-height: 1rem;
  text-align: center;
}
.rightIcon svg {
  font-size: 21px;
}
</style>
